const UA = window.navigator.userAgent || "";

export const getDate = (date: any, splitor = "-") => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${year}${splitor}${addZeroPrefix(month)}${splitor}${addZeroPrefix(
    day
  )}`;
};

export const getDates = (date: any, splitor = "-") => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const h = date.getHours();
  const minutes = date.getMinutes();
  return `${year}${splitor}${addZeroPrefix(month)}${splitor}${addZeroPrefix(
    day
  )}  ${addZeroPrefix(h)}:${addZeroPrefix(minutes)}`;
};

export const getTime = (date: any, withSecond = true) => {
  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();
  return withSecond
    ? `${addZeroPrefix(hour)}:${addZeroPrefix(minute)}:${addZeroPrefix(second)}`
    : `${hour}:${addZeroPrefix(minute)}`;
};

export const getFullDate = (date: any, time?: any) => {
  return `${getDate(date)} ${getTime(time || date)}`;
};

function addZeroPrefix(number: any) {
  return number < 10 ? `0${number}` : number;
}

export const getQueryString = (name: any) => {
  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};

export const isWX = () => {
  return UA.match(/micromessenger/i) || null;
};

export const isIos = () => {
  return UA.match(/iPhone|iPad|iPod/i) || null;
};

export const isAndroid = () => {
  return UA.match(/Android/i) || null;
};

export const getMode = () => {
  return process.env.VUE_APP_MODE;
};

/**
 * @description
 */
export const isPhoneNumber = (phoneNum: any) => {
  const reg =
    /^1(3[0-9]|4[5,7]|5[0,1,2,3,5,6,7,8,9]|6[2,5,6,7]|7[0,1,7,8]|8[0-9]|9[1,8,9])\d{8}$/;
  return reg.test(phoneNum);
};
